import { AWARDED_BORDER_COLOR, INNER_BORDER_COLOR, OUTER_BORDER_COLOR, WORKSHEET_GRAYED_OUT_FILL } from "./colors";

export const TOTAL_NUMBER_FORMAT: string = "#,##0_);(#,##0);-";
export const COSTPER_NUMBER_FORMAT = "#,##0.00_);(#,##0.00);-";
export const QUANTITY_NUMBER_FORMAT = TOTAL_NUMBER_FORMAT;
export const UNITCOST_NUMBER_FORMAT = COSTPER_NUMBER_FORMAT;
export const PERCENT_NUMBER_FORMAT = "0.000%;(0.000)%;-";
interface StyleDefault {
  styleName: string;
  styleProperties: Excel.Interfaces.StyleUpdateData;
  borders?: Excel.Interfaces.RangeBorderCollectionUpdateData;
  fillColor?: string;
}

export const quantityPlusUOMnumberFormat = (UOM: string) => {
  return QUANTITY_NUMBER_FORMAT.split(")").join(`) "${UOM}"`);
};

export const DEFAULT_STYLES: StyleDefault[] = [
  {
    styleName: "Header1",
    styleProperties: {
      font: { bold: true, size: 14 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "SectionHeader",
    styleProperties: {
      font: { bold: true, size: 14, underline: "Single" },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "Header2",
    styleProperties: {
      font: { bold: true, size: 13.5 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "Header3",
    styleProperties: {
      font: { bold: true, size: 13 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "Header4",
    styleProperties: {
      font: { bold: true, size: 12.5 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "PerSectionHeader",
    styleProperties: {
      font: { italic: true, bold: true, size: 14, underline: "Single" },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "PerHeader1",
    styleProperties: {
      font: { italic: true, bold: true, size: 14 },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "PerHeader2",
    styleProperties: {
      font: { italic: true, bold: true, size: 13.5 },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "PerHeader3",
    styleProperties: {
      font: { italic: true, bold: true, size: 13 },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "PerHeader4",
    styleProperties: {
      font: { italic: true, bold: true, size: 12.5 },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  // Group headers of an Estimate report with Hide Line Item Details on. Same defaults as Header1-4,
  // but a separate style so a workbook can give its SOV-style reports their own header look.
  {
    styleName: "SOVHeader1",
    styleProperties: {
      font: { bold: true, size: 14 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "SOVHeader2",
    styleProperties: {
      font: { bold: true, size: 13.5 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "SOVHeader3",
    styleProperties: {
      font: { bold: true, size: 13 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "SOVHeader4",
    styleProperties: {
      font: { bold: true, size: 12.5 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "PerSOVHeader1",
    styleProperties: {
      font: { italic: true, bold: true, size: 14 },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "PerSOVHeader2",
    styleProperties: {
      font: { italic: true, bold: true, size: 13.5 },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "PerSOVHeader3",
    styleProperties: {
      font: { italic: true, bold: true, size: 13 },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "PerSOVHeader4",
    styleProperties: {
      font: { italic: true, bold: true, size: 12.5 },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "Subtotal1",
    styleProperties: {
      font: { bold: true, size: 14 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "Subtotal2",
    styleProperties: {
      font: { bold: true, size: 13.5 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "Subtotal3",
    styleProperties: {
      font: { bold: true, size: 13 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "Subtotal4",
    styleProperties: {
      font: { bold: true, size: 12.5 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "PerSubtotal1",
    styleProperties: {
      font: { italic: true, bold: true, size: 14 },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "PerSubtotal2",
    styleProperties: {
      font: { italic: true, bold: true, size: 13.5 },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "PerSubtotal3",
    styleProperties: {
      font: { italic: true, bold: true, size: 13 },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "PerSubtotal4",
    styleProperties: {
      font: { italic: true, bold: true, size: 12.5 },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "Spacer",
    styleProperties: {
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "Item",
    styleProperties: {
      font: { size: 12 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "SpacerOuterBorderTop",
    styleProperties: {
      font: { size: 12 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeTop",
          style: "Continuous",
          color: OUTER_BORDER_COLOR,
          weight: "Medium",
        },
      ],
    },
  },
  {
    styleName: "SpacerOuterBorderLeft",
    styleProperties: {
      font: { size: 12 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeLeft",
          style: "Continuous",
          color: OUTER_BORDER_COLOR,
          weight: "Medium",
        },
      ],
    },
  },
  {
    styleName: "SpacerOuterBorderRight",
    styleProperties: {
      font: { size: 12 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeRight",
          style: "Continuous",
          color: OUTER_BORDER_COLOR,
          weight: "Medium",
        },
      ],
    },
  },
  {
    styleName: "SpacerOuterBorders",
    styleProperties: {
      font: { size: 12 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeRight",
          style: "Continuous",
          color: OUTER_BORDER_COLOR,
          weight: "Medium",
        },
        {
          sideIndex: "EdgeLeft",
          style: "Continuous",
          color: OUTER_BORDER_COLOR,
          weight: "Medium",
        },
      ],
    },
  },
  {
    styleName: "GridItem",
    styleProperties: {
      font: { size: 12 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeTop",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
        {
          sideIndex: "EdgeRight",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
        {
          sideIndex: "EdgeBottom",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
      ],
    },
  },
  {
    styleName: "Markup",
    styleProperties: {
      font: { size: 12 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "Spacer",
    styleProperties: {
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "CostPerColumn",
    styleProperties: {
      font: { italic: true, bold: false },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeLeft",
          style: "Dot",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
        {
          sideIndex: "EdgeBottom",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
      ],
    },
  },
  {
    styleName: "DetailCostPerColumn",
    styleProperties: {
      font: { italic: true, bold: false },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeLeft",
          style: "Dot",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
        {
          sideIndex: "EdgeBottom",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
      ],
    },
  },
  {
    styleName: "CostPerSubtotal",
    styleProperties: {
      font: { italic: true, bold: true },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeLeft",
          style: "Dot",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
        {
          sideIndex: "EdgeBottom",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
      ],
    },
  },
  {
    styleName: "DetailCostPerSubtotal",
    styleProperties: {
      font: { italic: true, bold: true },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeLeft",
          style: "Dot",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
        {
          sideIndex: "EdgeBottom",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
      ],
    },
  },
  {
    styleName: "CostPerGrandtotal",
    styleProperties: {
      font: { italic: true, bold: true },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeLeft",
          style: "Dot",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
        {
          sideIndex: "EdgeBottom",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
      ],
    },
  },
  {
    styleName: "DetailCostPerGrandtotal",
    styleProperties: {
      font: { italic: true, bold: true },
      numberFormat: COSTPER_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeLeft",
          style: "Dot",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
        {
          sideIndex: "EdgeBottom",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
      ],
    },
  },
  {
    styleName: "Denominators",
    styleProperties: {
      font: { italic: true, bold: true },
      verticalAlignment: "Center",
      includeAlignment: true,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "AssemblyItem",
    styleProperties: {
      font: { size: 11, italic: true },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
  },
  {
    styleName: "UnitSpecsHeader",
    styleProperties: {
      font: { bold: true, size: 14 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeTop",
          style: "Continuous",
          color: OUTER_BORDER_COLOR,
          weight: "Medium",
        },
        {
          sideIndex: "EdgeBottom",
          style: "Continuous",
          color: OUTER_BORDER_COLOR,
          weight: "Medium",
        },
      ],
    },
  },
  {
    styleName: "UnitTotalsHeader",
    styleProperties: {
      font: { bold: true, size: 14 },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeTop",
          style: "Continuous",
          color: OUTER_BORDER_COLOR,
          weight: "Medium",
        },
        {
          sideIndex: "EdgeBottom",
          style: "Continuous",
          color: OUTER_BORDER_COLOR,
          weight: "Medium",
        },
      ],
    },
  },
  {
    styleName: "BoughtCell",
    styleProperties: {
      includeAlignment: false,
      includeBorder: true,
      includeFont: false,
      includeNumber: false,
      includePatterns: false,
    },
    borders: {
      items: [
        { sideIndex: "EdgeTop", style: "Continuous", color: AWARDED_BORDER_COLOR, weight: "Medium" },
        { sideIndex: "EdgeBottom", style: "Continuous", color: AWARDED_BORDER_COLOR, weight: "Medium" },
        { sideIndex: "EdgeLeft", style: "Continuous", color: AWARDED_BORDER_COLOR, weight: "Medium" },
        { sideIndex: "EdgeRight", style: "Continuous", color: AWARDED_BORDER_COLOR, weight: "Medium" },
      ],
    },
  },
  {
    styleName: "GrayedOutCell",
    styleProperties: {
      font: { bold: false },
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: false,
      includePatterns: true,
    },
    fillColor: WORKSHEET_GRAYED_OUT_FILL,
    borders: {
      items: [
        { sideIndex: "EdgeTop", style: "None" },
        { sideIndex: "EdgeBottom", style: "None" },
        { sideIndex: "EdgeLeft", style: "None" },
        { sideIndex: "EdgeRight", style: "None" },
      ],
    },
  },
  {
    styleName: "BuyStatsTotalColumn",
    styleProperties: {
      font: { bold: false },
      numberFormat: TOTAL_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeBottom",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
        {
          sideIndex: "EdgeRight",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
      ],
    },
  },
  {
    styleName: "BuyStatsTotalCell",
    styleProperties: {
      font: { bold: true },
      numberFormat: TOTAL_NUMBER_FORMAT,
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
  },
  {
    styleName: "BuyStatsPercentColumn",
    styleProperties: {
      font: { bold: false },
      numberFormat: "0.00%",
      includeAlignment: false,
      includeBorder: true,
      includeFont: true,
      includeNumber: true,
      includePatterns: true,
    },
    borders: {
      items: [
        {
          sideIndex: "EdgeBottom",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
        {
          sideIndex: "EdgeRight",
          style: "Continuous",
          color: INNER_BORDER_COLOR,
          weight: "Thin",
        },
      ],
    },
  },
];

export interface rangeFormatting {
  rangeAddress: string;
  value?: string;
  name?: string;
  Halignment?: Excel.HorizontalAlignment | "Center" | "Left" | "Right";
  Valignment?: Excel.VerticalAlignment | "Center" | "Top" | "Bottom";
  numberFormat?: string;
  fontSize?: number;
  fontName?: string;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  indentLevel?: number;
}

export type edge = "EdgeTop" | "EdgeBottom" | "EdgeLeft" | "EdgeRight" | "InsideVertical" | "InsideHorizontal";

export const allEdges: edge[] = [
  "EdgeTop",
  "EdgeBottom",
  "EdgeLeft",
  "EdgeRight",
  "InsideVertical",
  "InsideHorizontal",
];
export const outerEdges: edge[] = ["EdgeTop", "EdgeBottom", "EdgeLeft", "EdgeRight"];
export const innerEdges: edge[] = ["InsideVertical", "InsideHorizontal"];

export interface GridStyleOptions {
  range: Excel.Range;
  borderColor: string;
  weight: Excel.BorderWeight | "Thin" | "Medium" | "Thick";
  edges?: edge[]; // Optional edges
}

export const ensureStylesExist = async () => {
  await Excel.run(async (context) => {
    const workbook = context.workbook;

    for (const defaultStyle of DEFAULT_STYLES) {
      try {
        // Check if the style exists in the workbook
        let style = workbook.styles.getItemOrNullObject(defaultStyle.styleName);
        await context.sync();

        // Only create and apply properties if the style does not exist
        if (style.isNullObject) {
          workbook.styles.add(defaultStyle.styleName);
          await context.sync();
          style = workbook.styles.getItem(defaultStyle.styleName);
          await context.sync();
          style.set(defaultStyle.styleProperties);
          await context.sync();
          if (defaultStyle.fillColor) {
            style.fill.color = defaultStyle.fillColor;
            await context.sync();
          }
          //its a real pain to set the borders, you can't put them in the styleProperties
          if (defaultStyle.borders && defaultStyle.borders.items) {
            style.load("borders/items/sideIndex");
            await context.sync();
            style.borders.items.map((border) => {
              const defaultBorder = defaultStyle.borders?.items?.find((b) => b.sideIndex === border.sideIndex);
              if (defaultBorder) {
                border.style = defaultBorder.style as Excel.BorderLineStyle;
                border.color = defaultBorder.color as string;
                border.weight = defaultBorder.weight as Excel.BorderWeight;
              }
            });
            await context.sync();
          }
        }
      } catch (error) {
        console.error(`Error ensuring style "${defaultStyle.styleName}" exists: ${error}`);
      }
    }
  });
};

export const applyGridStyle = ({ range, borderColor, weight, edges = outerEdges }: GridStyleOptions) => {
  edges.forEach((edge: edge) => {
    const borderItem = range.format.borders.getItem(edge);
    borderItem.style = Excel.BorderLineStyle.continuous;
    borderItem.weight = weight;
    borderItem.color = borderColor;
  });
};

export const applyRangeFormats = (sheet: Excel.Worksheet, rangeFormats: rangeFormatting[]) => {
  rangeFormats.forEach(
    ({
      rangeAddress,
      value,
      name,
      Halignment,
      Valignment,
      numberFormat,
      fontSize,
      fontName,
      bold,
      italic,
      underline,
      indentLevel,
    }) => {
      const range = sheet.getRange(rangeAddress);
      if (value) range.values = [[value]];
      if (Halignment) range.format.horizontalAlignment = Halignment;
      if (Valignment) range.format.verticalAlignment = Valignment;
      if (numberFormat) range.numberFormat = [[numberFormat]];
      const font = range.format.font;
      if (fontSize !== undefined) font.size = fontSize;
      if (fontName) font.name = fontName;
      if (bold !== undefined) font.bold = bold;
      if (italic !== undefined) font.italic = italic;
      if (underline !== undefined) font.underline = underline ? "Single" : "None";
      if (indentLevel !== undefined) range.format.indentLevel = indentLevel; // Apply indent level
      if (name) sheet.names.add(name, range);
    }
  );
};
